/**
 * @generated SignedSource<<a4859ff1d51f9c426d1e1df856771966>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type WidgetTodoSummary_widgetTodoSummary$data = {
  readonly category: {
    readonly id: string;
    readonly title: string;
  };
  readonly id: string;
  readonly teams: ReadonlyArray<{
    readonly id: string;
    readonly notResolvedCount: number;
    readonly team: {
      readonly color: string | null;
      readonly icon: TeamIcon | null;
      readonly id: string;
      readonly name: string;
    };
  }>;
  readonly title: string;
  readonly " $fragmentType": "WidgetTodoSummary_widgetTodoSummary";
};
export type WidgetTodoSummary_widgetTodoSummary$key = {
  readonly " $data"?: WidgetTodoSummary_widgetTodoSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoSummary_widgetTodoSummary">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTodoSummary_widgetTodoSummary",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "TodoCategory",
        "kind": "LinkedField",
        "name": "category",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      "action": "THROW"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategoryTeam",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notResolvedCount",
          "storageKey": null
        },
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "Team",
            "kind": "LinkedField",
            "name": "team",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "color",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "icon",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          "action": "THROW"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetTodoSummary",
  "abstractKey": null
};
})();

(node as any).hash = "8e966eab3485e46a7e4448ce05315030";

export default node;
